<template>
    <form-row title="Inspection Due Date">
        <div class="flex flex-col sm:flex-row sm:items-end">
            <div class="-mt-4">
                <input-date
                    label="Date"
                    name="inspection_date"
                    v-model="inspection_date"
                    @entered="dateEntered"
                    :read_only="read_only"
                    input_id="inspection-date"
                />
            </div>

            <div class="mt-4 sm:mt-0 flex items-center">
                <span class="text-sm text-gray-warm-800 sm:pl-6 pr-6">
                    {{ $t('- OR -') }}
                </span>

                <div class="w-16 sm:w-1/5">
                    <input-text
                        name="inspection_period"
                        v-model="inspection_period"
                        placeholder="Days"
                        :read_only="read_only"
                    />
                </div>

                <span class="text-sm text-gray-warm-800 leading-snug pl-4">
                    {{ $t('days after contract date') }}
                </span>
            </div>
        </div>
    </form-row>
</template>

<script>
import DateFunctions from '../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        inspection: { default: () => ({}) },
        contract_acceptance_date: {},
        read_only: { default: false },
    },

    data() {
        return {
            inspection_date: this.inspection.inspection_date,
            inspection_period: this.inspection.inspection_period,
        }
    },

    computed: {
        inspection_date_from_period() {
            if (! this.contract_acceptance_date) {
                return;
            }

            if (this.isValidDate(this.contract_acceptance_date) && this.inspection_period) {
                return dayjs(this.contract_acceptance_date.slice(0, 10))
                    .add({ day: this.inspection_period })
                    .format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        dateEntered() {
            this.inspection_period = null;
        },
    },

    watch: {
        inspection_date_from_period(val) {
            if (val) {
                this.inspection_date = val;
            }
        },
    },
}
</script>
